import { logger } from '@fiverr-private/obs';
import { getStepNavigationMap } from '../../components/identification/IdentificationForm/IdentificationContextProvider/navigation/stepNavigationMapFactory';

export const validateIdentificationModalOptions = ({ mode, initialStep } = {}) => {
    if (!mode || !initialStep) {return;}

    const stepNavigationMap = getStepNavigationMap({ mode });
    if (!stepNavigationMap[initialStep]) {
        const errorMessage = `Mode ${mode} doesn't support step [initialStep="${initialStep}"]`;
        logger.error(new Error(errorMessage), {
            description: errorMessage
        });
        throw new Error(errorMessage);
    }
};
